export default function PmaCreateProgressBar({
  active,
  percent = 0,
  label = '',
  done = false,
  currentUser = '',
  index = 0,
  total = 0,
  completedNames = [],
}) {
  if (!active && !done) return null;

  const value = Math.max(0, Math.min(100, Number(percent) || 0));
  const title = done ? 'Credentials file downloaded' : label || 'Creating lab accounts…';
  const finished = Array.isArray(completedNames) ? completedNames.filter(Boolean) : [];

  return (
    <div
      className="p-3 rounded-lg space-y-2"
      style={{ border: '1px solid var(--color-border)' }}
      role="status"
      aria-live="polite"
      aria-busy={active && !done}
    >
      <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
        <span className="theme-text font-medium">{title}</span>
        <span className="theme-text-secondary font-mono text-xs">
          {total > 0 && !done ? `${index + 1}/${total} · ` : ''}
          {value}%
        </span>
      </div>
      <div
        className="h-2 w-full overflow-hidden rounded"
        style={{ backgroundColor: 'var(--color-border)' }}
      >
        <div
          className="h-full rounded transition-[width] duration-500 ease-out"
          style={{
            width: `${value}%`,
            backgroundColor: done ? 'var(--color-success, #15803d)' : 'var(--color-primary, #1f4e79)',
          }}
        />
      </div>
      {active && !done && (
        <p className="text-xs theme-text-secondary">
          {currentUser ? (
            <>
              In process: <code className="font-mono">{currentUser}</code>
              {total > 0 ? ` · ${index + 1} of ${total}` : ''}. Waiting until this account finishes
              (timeout grows per user). Keep this tab open.
            </>
          ) : (
            'Creating on the lab host and preparing the Linux/VNC credentials file. Keep this tab open.'
          )}
        </p>
      )}
      {active && !done && finished.length > 0 && (
        <p className="text-xs theme-text-secondary">
          Finished: {finished.join(', ')}
        </p>
      )}
      {done && (
        <p className="text-xs theme-text-secondary">
          Download should have started with every user in this batch. Use “Download Linux/VNC
          credentials CSV” if it did not.
        </p>
      )}
    </div>
  );
}
